module.exports = __webpack_public_path__ + "static/media/hour.71814651.svg";